import { useState } from "react";
import {isEmpty} from "lodash";

function WithStage({form, children, isEditing}) {

    const getFormStage = () => {
        if(isEditing){
            return Object.keys(form.getState().values).length
        }
        const stages = Object.keys(form.getState().dirtyFields).map((field) => getFieldStage(field));
        return stages.length > 0 ? Math.max(...stages) : 0;
    }

    const getFieldStage = (field) => {
        if(isEditing){
            return 0
        }
        let stage = form.getRegisteredFields().indexOf(field);
        if (stage == -1) {
            stage = form.getRegisteredFields().length > 0 ? form.getRegisteredFields().length : Object.values(form.getState().values).length ;
        }
        return stage;
    }

    const updateStage = () => {
        let newStage = getFormStage();
        newStage > stage && setStage(newStage);
    }

    const resetStage = (field = null) => {
        setStage(field ? getFieldStage(field) : 0)
        updateStage()
    }

    const [stage, setStage] = useState(getFormStage());
    return <>{children({updateStage, getFieldStage, getFormStage, resetStage, stage})} </> ;
}

export default WithStage;